
// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// import Navbar from "../Navbar";
// import Footer from "../Footer";

// import "../styles/PlanCheckout.css";

// const subscriptionPlans = [
//     { months: 6, discount: 0 },
//     { months: 12, discount: 5 },
//     { months: 24, discount: 10 },
//     { months: 36, discount: 12 },
//     { months: 72, discount: 15 },
// ];

// const PlanCheckout = () => {

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const location = useLocation();
//     const navigate = useNavigate();
//     const selectedPlan = location.state?.plan;

//     const [orgName, setOrgName] = useState("");
//     const [employeeCount, setEmployeeCount] = useState("");
//     const [employeeError, setEmployeeError] = useState("");
//     const [contactNumber, setContactNumber] = useState("");
//     const [companyEmail, setCompanyEmail] = useState("");
//     const [companyLogo, setCompanyLogo] = useState(null);

//     const blockedDomains = [
//         "gmail.com",
//         "yahoo.com",
//         "outlook.com",
//         "hotmail.com",
//         "icloud.com",
//         "rediffmail.com",
//     ];

//     const isCompanyEmailValid = () => {
//         if (!companyEmail) return true;
//         if (!companyEmail.includes("@")) return false;

//         const domain = companyEmail.split("@")[1]?.toLowerCase();
//         if (!domain) return false;

//         return !blockedDomains.includes(domain);
//     };

//     const handleEmployeeChange = (e) => {
//         const value = e.target.value;

//         setEmployeeCount(value);

//         if (value === "") {
//             setEmployeeError("");
//             return;
//         }

//         if (Number(value) < 10) {
//             setEmployeeError("At least 10 employees are required.");
//         } else {
//             setEmployeeError("");
//         }
//     };

//    const calculateAmount = (months, discount) => {
//     if (!employeeCount || Number(employeeCount) < 10) {
//         return {
//             finalAmount: 0,
//             discountAmount: 0,
//             baseAmount: 0,
//         };
//     }

//     const employees = Number(employeeCount);

//     const monthlyPrice = Number(
//         selectedPlan.price.replace("₹", "").replace("+", "")
//     );

//     const baseAmount =
//         employees * monthlyPrice * months;

//     const discountAmount =
//         (baseAmount * discount) / 100;

//     const finalAmount = baseAmount - discountAmount;

//     return {
//         finalAmount,
//         discountAmount,
//         baseAmount,
//     };
// };

//     if (!selectedPlan) {
//         return (
//             <div>
//                 <Navbar />
//                 <div className="checkout-error">
//                     No plan selected.
//                 </div>
//                 <Footer />
//             </div>
//         );
//     }

//     return (
//         <div className="plan-checkout-wrapper">
//             <Navbar />

//             <section className="checkout-section">
//                 <div className="checkout-card">

//                     <button
//                         className="back-btn"
//                         onClick={() => navigate("/pricing")}
//                     >
//                         ← Back to Pricing
//                     </button>

//                     <h1>Subscription Checkout</h1>

//                     <div className="selected-plan-box">
//                         <h2>{selectedPlan.title}</h2>

//                         <div className="selected-plan-price">
//                             <div className="selected-price-amount">
//                                 {selectedPlan.price}
//                             </div>

//                             <div className="selected-price-duration">
//                                 Per User / Month
//                             </div>
//                         </div>

//                         <p className="selected-plan-users">
//                             {selectedPlan.users}
//                         </p>
//                     </div>

//                  <div className="checkout-form">

//     <div className="checkout-form-layout">

//         <div className="left-form-fields">
//             <input
//                 type="text"
//                 placeholder="Enter Organization Name"
//                 value={orgName}
//                 onChange={(e) =>
//                     setOrgName(e.target.value)
//                 }
//             />

//             <input
//                 type="number"
//                 min="10"
//                 placeholder="Enter Number of Employees"
//                 value={employeeCount}
//                 onChange={handleEmployeeChange}
//             />

//             {employeeError && (
//                 <p className="email-error">
//                     {employeeError}
//                 </p>
//             )}

//             <input
//                 type="text"
//                 placeholder="Enter Contact Number"
//                 value={contactNumber}
//                 onChange={(e) =>
//                     setContactNumber(e.target.value)
//                 }
//             />

//             <input
//                 type="email"
//                 placeholder="Enter Company Email"
//                 value={companyEmail}
//                 onChange={(e) =>
//                     setCompanyEmail(e.target.value)
//                 }
//             />

//             {!isCompanyEmailValid() && (
//                 <p className="email-error">
//                     Please enter a valid company email.
//                 </p>
//             )}
//         </div>

//      <div className="right-logo-upload">
//     <div className="logo-upload-box">
//         <label htmlFor="logoUpload">
//             {companyLogo
//                 ? companyLogo.name
//                 : "Upload Company Logo"}
//         </label>

//         <button
//             type="button"
//             className="choose-file-btn"
//             onClick={() =>
//                 document.getElementById("logoUpload").click()
//             }
//         >
//             Choose File
//         </button>

//         <input
//             id="logoUpload"
//             type="file"
//             accept="image/*"
//             onChange={(e) =>
//                 setCompanyLogo(e.target.files[0])
//             }
//         />
//     </div>
// </div>

//     </div>

// </div>

//                     <div className="pricing-calculation-box">
//                         <h2 style={{ color: "#55ff00" }}>
//                             Subscription Pricing
//                         </h2>

//                         {subscriptionPlans.map((plan, index) => {
//                             const pricing = calculateAmount(
//                                 plan.months,
//                                 plan.discount
//                             );

//                             return (
//                                 <div
//                                     key={index}
//                                     className="subscription-row"
//                                 >
//                                     <div className="subscription-left">
//                                         <div className="subscription-title">
//                                             {plan.months} Months
//                                         </div>

//                                         {plan.discount > 0 && (
//                                             <div className="subscription-discount">
//                                                 {plan.discount}% Discount Applied
//                                                 (Saved ₹
//                                                 {pricing.discountAmount.toLocaleString()})
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div className="subscription-price">
//                                         ₹{pricing.finalAmount.toLocaleString()}
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </section>

//             <Footer />
//         </div>
//     );
// };

// export default PlanCheckout;















// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// import Navbar from "../Navbar";
// import Footer from "../Footer";

// import "../styles/PlanCheckout.css";

// const subscriptionPlans = [
//     { months: 6, discount: 0 },
//     { months: 12, discount: 5 },
//     { months: 24, discount: 10 },
//     { months: 36, discount: 12 },
//     { months: 72, discount: 15 },
// ];

// const PlanCheckout = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const location = useLocation();
//     const navigate = useNavigate();
//     const selectedPlan = location.state?.plan;

//     // Form States
//     const [orgName, setOrgName] = useState("");
//     const [employeeCount, setEmployeeCount] = useState("");
//     const [employeeError, setEmployeeError] = useState("");
//     const [contactNumber, setContactNumber] = useState("");
//     const [companyEmail, setCompanyEmail] = useState("");
//     const [companyLogo, setCompanyLogo] = useState(null);

//     // Duration States
//     const [selectedMonths, setSelectedMonths] = useState(6);
//     const [selectedDiscount, setSelectedDiscount] = useState(0);

//     // GST Feature States
//     const [isGstSelected, setIsGstSelected] = useState(false);
//     const [gstNumber, setGstNumber] = useState("");

//     const blockedDomains = [
//         "gmail.com",
//         "yahoo.com",
//         "outlook.com",
//         "hotmail.com",
//         "icloud.com",
//         "rediffmail.com",
//     ];

//     const isCompanyEmailValid = () => {
//         if (!companyEmail) return true;
//         if (!companyEmail.includes("@")) return false;

//         const domain = companyEmail.split("@")[1]?.toLowerCase();
//         if (!domain) return false;

//         return !blockedDomains.includes(domain);
//     };

//     const handleEmployeeChange = (e) => {
//         const value = e.target.value;
//         setEmployeeCount(value);

//         if (value === "") {
//             setEmployeeError("");
//             return;
//         }

//         if (Number(value) < 10) {
//             setEmployeeError("At least 10 employees are required.");
//         } else {
//             setEmployeeError("");
//         }
//     };

//     const calculateAmount = (months, discount) => {
//         if (!employeeCount || Number(employeeCount) < 10 || !selectedPlan) {
//             return {
//                 finalAmount: 0,
//                 discountAmount: 0,
//                 baseAmount: 0,
//             };
//         }

//         const employees = Number(employeeCount);
//         const monthlyPrice = Number(
//             selectedPlan.price
//                 .replace("₹", "")
//                 .replace("+", "")
//                 .replace(",", "")
//         );

//         const baseAmount = employees * monthlyPrice * months;
//         const discountAmount = (baseAmount * discount) / 100;
//         const finalAmount = baseAmount - discountAmount;

//         return {
//             finalAmount,
//             discountAmount,
//             baseAmount,
//         };
//     };

//     if (!selectedPlan) {
//         return (
//             <div>
//                 <Navbar />
//                 <div className="checkout-error">No plan selected.</div>
//                 <Footer />
//             </div>
//         );
//     }

//     const pricing = calculateAmount(selectedMonths, selectedDiscount);
//     const cgst = (pricing.finalAmount * 9) / 100;
//     const sgst = (pricing.finalAmount * 9) / 100;
//     const grandTotal = pricing.finalAmount + cgst + sgst;

//     return (
//         <div className="plan-checkout-wrapper">
//             <Navbar />

//             <section className="checkout-section">
//                 {/* TOP NAVIGATION HEADER */}
//                 <div className="checkout-header">
//                     <button className="backs-btn" onClick={() => navigate("/pricing")}>
//                         ← Back to Pricing
//                     </button>
//                     <h1>Subscription Checkout</h1>
//                 </div>

//                 {/* TWO-COLUMN SPLIT GRID LAYOUT */}
//                 <div className="checkout-main-layout">

//                     {/* LEFT COLUMN: INFORMATION & CONFIGURATION */}
//                     <div className="checkout-left-column">

//                         {/* 1. PLAN CONFIGURATION CARD */}
//                         <div className="checkout-card selected-plan-preview-card">
//                             <div className="card-header-accent">
//                                 <span className="badge">Selected Plan</span>
//                             </div>

//                             <div className="selected-plan-top">
//                                 <div>
//                                     <h3>{selectedPlan.title}</h3>
//                                     <p className="selected-plan-users">{selectedPlan.users}</p>
//                                 </div>
//                                 <div className="plan-price-box">
//                                     <span className="price-num">{selectedPlan.price}</span>
//                                     <span className="price-unit">/user/month</span>
//                                 </div>
//                             </div>

//                             <div className="subscription-dropdown-inside">
//                                 <label htmlFor="tenure-select">Subscription Duration</label>
//                                 <select
//                                     id="tenure-select"
//                                     value={selectedMonths}
//                                     onChange={(e) => {
//                                         const selected = subscriptionPlans.find(
//                                             (p) => p.months === Number(e.target.value)
//                                         );
//                                         setSelectedMonths(selected.months);
//                                         setSelectedDiscount(selected.discount);
//                                     }}
//                                 >
//                                     {subscriptionPlans.map((plan, index) => (
//                                         <option key={index} value={plan.months}>
//                                             {plan.months} Months {plan.discount > 0 ? `(${plan.discount}% Eco-Save OFF)` : ""}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>

//                         {/* 2. CUSTOMER DETAILS FORM CARD */}
//                         <div className="checkout-card checkout-form-card">
//                             <h2>Organization Details</h2>
//                             <p className="form-subtitle">Please fill out your corporate profile below to establish account management defaults.</p>

//                             <div className="form-grid-layout">
//                                 <div className="input-group">
//                                     <label>Organization Name</label>
//                                     <input
//                                         type="text"
//                                         placeholder="e.g. Acme Corporation"
//                                         value={orgName}
//                                         onChange={(e) => setOrgName(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Number of Employees</label>
//                                     <input
//                                         type="number"
//                                         min="10"
//                                         placeholder="Minimum 10 seats required"
//                                         value={employeeCount}
//                                         onChange={handleEmployeeChange}
//                                     />
//                                     {employeeError && <p className="field-error-message">{employeeError}</p>}
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Contact Phone Number</label>
//                                     <input
//                                         type="text"
//                                         placeholder="+91 XXXXX XXXXX"
//                                         value={contactNumber}
//                                         onChange={(e) => setContactNumber(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Company Email Address</label>
//                                     <input
//                                         type="email"
//                                         placeholder="name@yourcompany.com"
//                                         value={companyEmail}
//                                         onChange={(e) => setCompanyEmail(e.target.value)}
//                                     />
//                                     {!isCompanyEmailValid() && (
//                                         <p className="field-error-message">Please enter a valid company business email domain.</p>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* LOGO UPLOAD COMPONENT */}
//                             <div className="logo-upload-container">
//                                 <label className="upload-title">Company Logo Display</label>
//                                 <div className="logo-upload-box">
//                                     <div className="logo-meta-info">
//                                         <span className="file-status-text">
//                                             {companyLogo ? companyLogo.name : "No file chosen (Optional)"}
//                                         </span>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         className="choose-file-btn"
//                                         onClick={() => document.getElementById("logoUpload").click()}
//                                     >
//                                         Choose File
//                                     </button>
//                                     <input
//                                         id="logoUpload"
//                                         type="file"
//                                         accept="image/*"
//                                         style={{ display: "none" }}
//                                         onChange={(e) => setCompanyLogo(e.target.files[0])}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* RIGHT COLUMN: DYNAMIC ITEMIZED RECEIPT STICKY PANEL */}
//                     <div className="checkout-right-column">
//                         <div className="receipt-card sticky-receipt">
//                             <div className="receipt-header">
//                                 <h2>Receipt Summary</h2>
//                                 <span className="receipt-status-indicator">Live Calculation</span>
//                             </div>

//                             <div className="receipt-body">
//                                 <div className="receipt-row">
//                                     <span className="row-label">Selected Tier</span>
//                                     <span className="row-value plan-title-highlight">{selectedPlan.title}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Assigned Seats</span>
//                                     <span className="row-value font-numeric">{employeeCount || 0} Employees</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Rate / User / Month</span>
//                                     <span className="row-value font-numeric">{selectedPlan.price}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Subscription Term</span>
//                                     <span className="row-value font-numeric">{selectedMonths} Months</span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row">
//                                     <span className="row-label">Base Cost</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.baseAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-row discount-row">
//                                     <span className="row-label">Tenure Discount ({selectedDiscount}%)</span>
//                                     <span className="row-value font-numeric">
//                                         - ₹{pricing.discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row subtotal-row">
//                                     <span className="row-label">Taxable Subtotal</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.finalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">CGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">SGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider thick-divider"></div>

//                                 <div className="receipt-row grand-total-row">
//                                     <span className="total-label">Grand Total</span>
//                                     <span className="total-amount-display">
//                                         ₹{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 {/* GST COMPLIANCE MODULE */}
//                                 <div className="gst-compliance-box">
//                                     <label className="gst-checkbox-custom-label">
//                                         <input
//                                             type="checkbox"
//                                             checked={isGstSelected}
//                                             onChange={(e) => setIsGstSelected(e.target.checked)}
//                                         />
//                                         <span className="checkbox-text">Claim Corporate GST Credit?</span>
//                                     </label>

//                                     {isGstSelected && (
//                                         <div className="gst-input-slide-field">
//                                             <label>GSTIN Number</label>
//                                             <input
//                                                 type="text"
//                                                 maxLength={15}
//                                                 placeholder="e.g. 27AAAAA1111A1Z1"
//                                                 value={gstNumber}
//                                                 onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 <button 
//                                     className="checkout-submit-payment-btn"
//                                     disabled={!orgName || !employeeCount || !!employeeError || !isCompanyEmailValid() || (isGstSelected && gstNumber.length < 15)}
//                                 >
//                                     Proceed to Secure Payment
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </section>

//             <Footer />
//         </div>
//     );
// };

// export default PlanCheckout;


































// import React, { useState, useEffect } from "react";
// import { load } from "@cashfreepayments/cashfree-js";
// import { useLocation, useNavigate } from "react-router-dom";

// import Navbar from "../Navbar";
// import Footer from "../Footer";

// import "../styles/PlanCheckout.css";

// const subscriptionPlans = [
//     { months: 6, discount: 0 },
//     { months: 12, discount: 5 },
//     { months: 24, discount: 10 },
//     { months: 36, discount: 12 },
//     { months: 72, discount: 15 },
// ];

// const PlanCheckout = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const location = useLocation();
//     const navigate = useNavigate();
//     const selectedPlan = location.state?.plan;

//     // Form States
//     const [orgName, setOrgName] = useState("");
//     const [employeeCount, setEmployeeCount] = useState("");
//     const [employeeError, setEmployeeError] = useState("");
//     const [contactNumber, setContactNumber] = useState("");
//     const [companyEmail, setCompanyEmail] = useState("");
//     const [companyLogo, setCompanyLogo] = useState(null);

//     // Duration States
//     const [selectedMonths, setSelectedMonths] = useState(6);
//     const [selectedDiscount, setSelectedDiscount] = useState(0);

//     // GST Feature States
//     const [isGstSelected, setIsGstSelected] = useState(false);
//     const [gstNumber, setGstNumber] = useState("");

//     const blockedDomains = [
//         "gmail.com",
//         "yahoo.com",
//         "outlook.com",
//         "hotmail.com",
//         "icloud.com",
//         "rediffmail.com",
//     ];

//     const isCompanyEmailValid = () => {
//         if (!companyEmail) return true;
//         if (!companyEmail.includes("@")) return false;

//         const domain = companyEmail.split("@")[1]?.toLowerCase();
//         if (!domain) return false;

//         return !blockedDomains.includes(domain);
//     };

//     const handleEmployeeChange = (e) => {
//         const value = e.target.value;
//         setEmployeeCount(value);

//         if (value === "") {
//             setEmployeeError("");
//             return;
//         }

//         if (Number(value) < 10) {
//             setEmployeeError("At least 10 employees are required.");
//         } else {
//             setEmployeeError("");
//         }
//     };

//     const calculateAmount = (months, discount) => {
//         if (!employeeCount || Number(employeeCount) < 10 || !selectedPlan) {
//             return {
//                 finalAmount: 0,
//                 discountAmount: 0,
//                 baseAmount: 0,
//             };
//         }

//         const employees = Number(employeeCount);
//         const monthlyPrice = Number(
//             selectedPlan.price
//                 .replace("₹", "")
//                 .replace("+", "")
//                 .replace(",", "")
//         );

//         const baseAmount = employees * monthlyPrice * months;
//         const discountAmount = (baseAmount * discount) / 100;
//         const finalAmount = baseAmount - discountAmount;

//         return {
//             finalAmount,
//             discountAmount,
//             baseAmount,
//         };
//     };

//     if (!selectedPlan) {
//         return (
//             <div>
//                 <Navbar />
//                 <div className="checkout-error">No plan selected.</div>
//                 <Footer />
//             </div>
//         );
//     }

//     const pricing = calculateAmount(selectedMonths, selectedDiscount);
//     const cgst = (pricing.finalAmount * 9) / 100;
//     const sgst = (pricing.finalAmount * 9) / 100;
//     const grandTotal = pricing.finalAmount + cgst + sgst;

//     const handlePayment = async () => {
//         try {
//             if (!orgName || !employeeCount || employeeError || !isCompanyEmailValid()) {
//                 alert("Please fill all required details correctly");
//                 return;
//             }

//             const formData = new FormData();

//             formData.append("amount", Number(grandTotal.toFixed(2)));
//             formData.append("orgName", orgName);
//             formData.append("employeeCount", employeeCount);
//             formData.append("contactNumber", contactNumber);
//             formData.append("companyEmail", companyEmail);
//             formData.append("selectedMonths", selectedMonths);
//             formData.append("selectedPlan", selectedPlan.title);
//             formData.append("gstNumber", isGstSelected ? gstNumber : "");

//             if (companyLogo) {
//                 formData.append("companyLogo", companyLogo);
//             }

//             const response = await fetch("/gt-api/create_cashfree_order.php", {
//                 method: "POST",
//                 body: formData,
//             });
//             const rawText = await response.text();
//             console.log("RAW PHP RESPONSE:", rawText);

//             const data = JSON.parse(rawText);

//             console.log("Cashfree backend response:", data);

//             if (!data.success) {
//                 alert(JSON.stringify(data));
//                 return;
//             }
//             console.log("Full Backend Response:", data);
//             console.log("Session ID:", data.payment_session_id);

//             const cashfree = await load({
//                 mode: "production",
//             });
//             await cashfree.checkout({
//                 paymentSessionId: data.payment_session_id,
//                 redirectTarget: "_self",
//             });

//         } catch (error) {
//             console.error("Cashfree Error:", error);
//             alert(error.message || JSON.stringify(error));
//         }
//     };


//     return (
//         <div className="plan-checkout-wrapper">
//             <Navbar />

//             <section className="checkout-section">
//                 {/* TOP NAVIGATION HEADER */}
//                 <div className="checkout-header">
//                     <button className="backs-btn" onClick={() => navigate("/pricing")}>
//                         ← Back to Pricing
//                     </button>
//                     <h1>Subscription Checkout</h1>
//                 </div>

//                 {/* TWO-COLUMN SPLIT GRID LAYOUT */}
//                 <div className="checkout-main-layout">

//                     {/* LEFT COLUMN: INFORMATION & CONFIGURATION */}
//                     <div className="checkout-left-column">

//                         {/* 1. PLAN CONFIGURATION CARD */}
//                         <div className="checkout-card selected-plan-preview-card">
//                             <div className="card-header-accent">
//                                 <span className="badge">Selected Plan</span>
//                             </div>

//                             <div className="selected-plan-top">
//                                 <div>
//                                     <h3>{selectedPlan.title}</h3>
//                                     <p className="selected-plan-users">{selectedPlan.users}</p>
//                                 </div>
//                                 <div className="plan-price-box">
//                                     <span className="price-num">{selectedPlan.price}</span>
//                                     <span className="price-unit">/user/month</span>
//                                 </div>
//                             </div>

//                             <div className="subscription-dropdown-inside">
//                                 <label htmlFor="tenure-select">Subscription Duration</label>
//                                 <select
//                                     id="tenure-select"
//                                     value={selectedMonths}
//                                     onChange={(e) => {
//                                         const selected = subscriptionPlans.find(
//                                             (p) => p.months === Number(e.target.value)
//                                         );
//                                         setSelectedMonths(selected.months);
//                                         setSelectedDiscount(selected.discount);
//                                     }}
//                                 >
//                                     {subscriptionPlans.map((plan, index) => (
//                                         <option key={index} value={plan.months}>
//                                             {plan.months} Months {plan.discount > 0 ? `(${plan.discount}% Eco-Save OFF)` : ""}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>

//                         {/* 2. CUSTOMER DETAILS FORM CARD */}
//                         <div className="checkout-card checkout-form-card">
//                             <h2>Organization Details</h2>
//                             <p className="form-subtitle">Please fill out your corporate profile below to establish account management defaults.</p>

//                             <div className="form-grid-layout">
//                                 <div className="input-group">
//                                     <label>Organization Name</label>
//                                     <input
//                                         type="text"
//                                         placeholder="e.g. Abc Corporation"
//                                         value={orgName}
//                                         onChange={(e) => setOrgName(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Number of Employees</label>
//                                     <input
//                                         type="number"
//                                         min="10"
//                                         placeholder="Minimum 10 seats required"
//                                         value={employeeCount}
//                                         onChange={handleEmployeeChange}
//                                     />
//                                     {employeeError && <p className="field-error-message">{employeeError}</p>}
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Contact Phone Number</label>
//                                     <input
//                                         type="text"
//                                         placeholder="+91 XXXXX XXXXX"
//                                         value={contactNumber}
//                                         onChange={(e) => setContactNumber(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Company Email Address</label>
//                                     <input
//                                         type="email"
//                                         placeholder="name@yourcompany.com"
//                                         value={companyEmail}
//                                         onChange={(e) => setCompanyEmail(e.target.value)}
//                                     />
//                                     {!isCompanyEmailValid() && (
//                                         <p className="field-error-message">Please enter a valid company business email domain.</p>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* LOGO UPLOAD COMPONENT */}
//                             <div className="logo-upload-container">
//                                 <label className="upload-title">Company Logo Display</label>
//                                 <div className="logo-upload-box">
//                                     <div className="logo-meta-info">
//                                         <span className="file-status-text">
//                                             {companyLogo ? companyLogo.name : "No file chosen (Optional)"}
//                                         </span>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         className="choose-file-btn"
//                                         onClick={() => document.getElementById("logoUpload").click()}
//                                     >
//                                         Choose File
//                                     </button>
//                                     <input
//                                         id="logoUpload"
//                                         type="file"
//                                         accept="image/*"
//                                         style={{ display: "none" }}
//                                         onChange={(e) => setCompanyLogo(e.target.files[0])}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* RIGHT COLUMN: DYNAMIC ITEMIZED RECEIPT STICKY PANEL */}
//                     <div className="checkout-right-column">
//                         <div className="receipt-card sticky-receipt">
//                             <div className="receipt-header">
//                                 <h2>Receipt Summary</h2>
//                                 <span className="receipt-status-indicator">Live Calculation</span>
//                             </div>

//                             <div className="receipt-body">
//                                 <div className="receipt-row">
//                                     <span className="row-label">Selected Tier</span>
//                                     <span className="row-value plan-title-highlight">{selectedPlan.title}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Assigned Seats</span>
//                                     <span className="row-value font-numeric">{employeeCount || 0} Employees</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Rate / User / Month</span>
//                                     <span className="row-value font-numeric">{selectedPlan.price}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Subscription Term</span>
//                                     <span className="row-value font-numeric">{selectedMonths} Months</span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row">
//                                     <span className="row-label">Base Cost</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.baseAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-row discount-row">
//                                     <span className="row-label">Tenure Discount ({selectedDiscount}%)</span>
//                                     <span className="row-value font-numeric">
//                                         - ₹{pricing.discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row subtotal-row">
//                                     <span className="row-label">Taxable Subtotal</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.finalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">CGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">SGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider thick-divider"></div>

//                                 <div className="receipt-row grand-total-row">
//                                     <span className="total-label">Grand Total</span>
//                                     <span className="total-amount-display">
//                                         ₹{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 {/* GST COMPLIANCE MODULE */}
//                                 <div className="gst-compliance-box">
//                                     <label className="gst-checkbox-custom-label">
//                                         <input
//                                             type="checkbox"
//                                             checked={isGstSelected}
//                                             onChange={(e) => setIsGstSelected(e.target.checked)}
//                                         />
//                                         <span className="checkbox-text">Claim Corporate GST Credit?</span>
//                                     </label>

//                                     {isGstSelected && (
//                                         <div className="gst-input-slide-field">
//                                             <label>GSTIN Number</label>
//                                             <input
//                                                 type="text"
//                                                 maxLength={15}
//                                                 placeholder="e.g. 27AAAAA1111A1Z1"
//                                                 value={gstNumber}
//                                                 onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 <button
//                                     className="checkout-submit-payment-btn"
//                                     onClick={handlePayment}
//                                     disabled={
//                                         !orgName ||
//                                         !employeeCount ||
//                                         !!employeeError ||
//                                         !isCompanyEmailValid() ||
//                                         (isGstSelected && gstNumber.length < 15)
//                                     }
//                                 >
//                                     Proceed to Secure Payment
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </section>

//             <Footer />
//         </div>
//     );
// };

// export default PlanCheckout;



















// import React, { useState, useEffect } from "react";
// import { load } from "@cashfreepayments/cashfree-js";
// import { useLocation, useNavigate } from "react-router-dom";

// import Navbar from "../Navbar";
// import Footer from "../Footer";

// import "../styles/PlanCheckout.css";

// const subscriptionPlans = [
//     { months: 6, discount: 0 },
//     { months: 12, discount: 5 },
//     { months: 24, discount: 10 },
//     { months: 36, discount: 12 },
//     { months: 72, discount: 15 },
// ];

// const PlanCheckout = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const location = useLocation();
//     const navigate = useNavigate();
//    const selectedPlan = location.state?.plan;
// const selectedProduct = location.state?.product;

//     // Form States
//     const [orgName, setOrgName] = useState("");
//     const [employeeCount, setEmployeeCount] = useState("");
//     const [employeeError, setEmployeeError] = useState("");
//     const [contactNumber, setContactNumber] = useState("");
//     const [companyEmail, setCompanyEmail] = useState("");
//     const [companyLogo, setCompanyLogo] = useState(null);

//     // Duration States
//     const [selectedMonths, setSelectedMonths] = useState(6);
//     const [selectedDiscount, setSelectedDiscount] = useState(0);

//     // GST Feature States
//     const [isGstSelected, setIsGstSelected] = useState(false);
//     const [gstNumber, setGstNumber] = useState("");

//     const blockedDomains = [
//         "gmail.com",
//         "yahoo.com",
//         "outlook.com",
//         "hotmail.com",
//         "icloud.com",
//         "rediffmail.com",
//     ];

//     const isCompanyEmailValid = () => {
//         if (!companyEmail) return true;
//         if (!companyEmail.includes("@")) return false;

//         const domain = companyEmail.split("@")[1]?.toLowerCase();
//         if (!domain) return false;

//         return !blockedDomains.includes(domain);
//     };

//     const handleEmployeeChange = (e) => {
//         const value = e.target.value;
//         setEmployeeCount(value);

//         if (value === "") {
//             setEmployeeError("");
//             return;
//         }

//         if (Number(value) < 10) {
//             setEmployeeError("At least 10 employees are required.");
//         } else {
//             setEmployeeError("");
//         }
//     };

//     const calculateAmount = (months, discount) => {
//         if (!employeeCount || Number(employeeCount) < 10 || !selectedPlan) {
//             return {
//                 finalAmount: 0,
//                 discountAmount: 0,
//                 baseAmount: 0,
//             };
//         }

//         const employees = Number(employeeCount);
//         const monthlyPrice = Number(
//             selectedPlan.price
//                 .replace("₹", "")
//                 .replace("+", "")
//                 .replace(",", "")
//         );

//         const baseAmount = employees * monthlyPrice * months;
//         const discountAmount = (baseAmount * discount) / 100;
//         const finalAmount = baseAmount - discountAmount;

//         return {
//             finalAmount,
//             discountAmount,
//             baseAmount,
//         };
//     };

//     if (!selectedPlan) {
//         return (
//             <div>
//                 <Navbar />
//                 <div className="checkout-error">No plan selected.</div>
//                 <Footer />
//             </div>
//         );
//     }

//     const pricing = calculateAmount(selectedMonths, selectedDiscount);
//     const cgst = (pricing.finalAmount * 9) / 100;
//     const sgst = (pricing.finalAmount * 9) / 100;
//     const grandTotal = pricing.finalAmount + cgst + sgst;

//     const handlePayment = async () => {
//         try {
//             if (!orgName || !employeeCount || employeeError || !isCompanyEmailValid()) {
//                 alert("Please fill all required details correctly");
//                 return;
//             }

//             const formData = new FormData();

//             formData.append("amount", Number(grandTotal.toFixed(2)));
//             formData.append("orgName", orgName);
//             formData.append("employeeCount", employeeCount);
//             formData.append("contactNumber", contactNumber);
//             formData.append("companyEmail", companyEmail);
//             formData.append("selectedMonths", selectedMonths);
//             formData.append("selectedPlan", selectedPlan.title);
//             formData.append("gstNumber", isGstSelected ? gstNumber : "");

//             if (companyLogo) {
//                 formData.append("companyLogo", companyLogo);
//             }

//             const response = await fetch("/gt-api/create_cashfree_order.php", {
//                 method: "POST",
//                 body: formData,
//             });
//             const rawText = await response.text();
//             console.log("RAW PHP RESPONSE:", rawText);

//             const data = JSON.parse(rawText);

//             console.log("Cashfree backend response:", data);

//             if (!data.success) {
//                 alert(JSON.stringify(data));
//                 return;
//             }
//             console.log("Full Backend Response:", data);
//             console.log("Session ID:", data.payment_session_id);

//             const cashfree = await load({
//                 mode: "production",
//             });
//             await cashfree.checkout({
//                 paymentSessionId: data.payment_session_id,
//                 redirectTarget: "_self",
//             });

//         } catch (error) {
//             console.error("Cashfree Error:", error);
//             alert(error.message || JSON.stringify(error));
//         }
//     };


//     return (
//         <div className="plan-checkout-wrapper">
//             <Navbar />

//             <section className="checkout-section">
//                 {/* TOP NAVIGATION HEADER */}
//                 <div className="checkout-header">
//                     <button className="backs-btn" onClick={() => navigate("/pricing")}>
//                         ← Back to Pricing
//                     </button>
//                     <h1>Subscription Checkout</h1>
//                 </div>

//                 {/* TWO-COLUMN SPLIT GRID LAYOUT */}
//                 <div className="checkout-main-layout">

//                     {/* LEFT COLUMN: INFORMATION & CONFIGURATION */}
//                     <div className="checkout-left-column">

//                         {/* 1. PLAN CONFIGURATION CARD */}
//                         <div className="checkout-card selected-plan-preview-card">
//                             <div className="card-header-accent">
//                                 <span className="badge">Selected Plan</span>
//                             </div>

//                             <div className="selected-plan-top">
//                               <div>
//     {selectedProduct && (
//         <div
//             style={{
//                 marginBottom: "12px",
//                 color: "#17d327",
//                 fontSize: "14px",
//                 fontWeight: "700",
//             }}
//         >
//             Product: {selectedProduct.name}
//         </div>
//     )}

//     <h3>{selectedPlan.title}</h3>

//     <p className="selected-plan-users">
//         {selectedPlan.users}
//     </p>
// </div>
//                                 <div className="plan-price-box">
//                                     <span className="price-num">{selectedPlan.price}</span>
//                                     <span className="price-unit">/user/month</span>
//                                 </div>
//                             </div>

//                             <div className="subscription-dropdown-inside">
//                                 <label htmlFor="tenure-select">Subscription Duration</label>
//                                 <select
//                                     id="tenure-select"
//                                     value={selectedMonths}
//                                     onChange={(e) => {
//                                         const selected = subscriptionPlans.find(
//                                             (p) => p.months === Number(e.target.value)
//                                         );
//                                         setSelectedMonths(selected.months);
//                                         setSelectedDiscount(selected.discount);
//                                     }}
//                                 >
//                                     {subscriptionPlans.map((plan, index) => (
//                                         <option key={index} value={plan.months}>
//                                             {plan.months} Months {plan.discount > 0 ? `(${plan.discount}% Eco-Save OFF)` : ""}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>

//                         {/* 2. CUSTOMER DETAILS FORM CARD */}
//                         <div className="checkout-card checkout-form-card">
//                             <h2>Organization Details</h2>
//                             <p className="form-subtitle">Please fill out your corporate profile below to establish account management defaults.</p>

//                             <div className="form-grid-layout">
//                                 <div className="input-group">
//                                     <label>Organization Name</label>
//                                     <input
//                                         type="text"
//                                         placeholder="e.g. Abc Corporation"
//                                         value={orgName}
//                                         onChange={(e) => setOrgName(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Number of Employees</label>
//                                     <input
//                                         type="number"
//                                         min="10"
//                                         placeholder="Minimum 10 seats required"
//                                         value={employeeCount}
//                                         onChange={handleEmployeeChange}
//                                     />
//                                     {employeeError && <p className="field-error-message">{employeeError}</p>}
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Contact Phone Number</label>
//                                     <input
//                                         type="text"
//                                         placeholder="+91 XXXXX XXXXX"
//                                         value={contactNumber}
//                                         onChange={(e) => setContactNumber(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Company Email Address</label>
//                                     <input
//                                         type="email"
//                                         placeholder="name@yourcompany.com"
//                                         value={companyEmail}
//                                         onChange={(e) => setCompanyEmail(e.target.value)}
//                                     />
//                                     {!isCompanyEmailValid() && (
//                                         <p className="field-error-message">Please enter a valid company business email domain.</p>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* LOGO UPLOAD COMPONENT */}
//                             <div className="logo-upload-container">
//                                 <label className="upload-title">Company Logo Display</label>
//                                 <div className="logo-upload-box">
//                                     <div className="logo-meta-info">
//                                         <span className="file-status-text">
//                                             {companyLogo ? companyLogo.name : "No file chosen (Optional)"}
//                                         </span>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         className="choose-file-btn"
//                                         onClick={() => document.getElementById("logoUpload").click()}
//                                     >
//                                         Choose File
//                                     </button>
//                                     <input
//                                         id="logoUpload"
//                                         type="file"
//                                         accept="image/*"
//                                         style={{ display: "none" }}
//                                         onChange={(e) => setCompanyLogo(e.target.files[0])}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* RIGHT COLUMN: DYNAMIC ITEMIZED RECEIPT STICKY PANEL */}
//                     <div className="checkout-right-column">
//                         <div className="receipt-card sticky-receipt">
//                             <div className="receipt-header">
//                                 <h2>Receipt Summary</h2>
//                                 <span className="receipt-status-indicator">Live Calculation</span>
//                             </div>

//                             <div className="receipt-body">

//                                 {selectedProduct && (
//     <div className="receipt-row">
//         <span className="row-label">
//             Product
//         </span>

//         <span className="row-value plan-title-highlight">
//             {selectedProduct.name}
//         </span>
//     </div>
// )}
//                                 <div className="receipt-row">
//                                     <span className="row-label">Selected Tier</span>
//                                     <span className="row-value plan-title-highlight">{selectedPlan.title}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Assigned Seats</span>
//                                     <span className="row-value font-numeric">{employeeCount || 0} Employees</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Rate / User / Month</span>
//                                     <span className="row-value font-numeric">{selectedPlan.price}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Subscription Term</span>
//                                     <span className="row-value font-numeric">{selectedMonths} Months</span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row">
//                                     <span className="row-label">Base Cost</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.baseAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-row discount-row">
//                                     <span className="row-label">Tenure Discount ({selectedDiscount}%)</span>
//                                     <span className="row-value font-numeric">
//                                         - ₹{pricing.discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row subtotal-row">
//                                     <span className="row-label">Taxable Subtotal</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.finalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">CGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">SGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider thick-divider"></div>

//                                 <div className="receipt-row grand-total-row">
//                                     <span className="total-label">Grand Total</span>
//                                     <span className="total-amount-display">
//                                         ₹{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 {/* GST COMPLIANCE MODULE */}
//                                 <div className="gst-compliance-box">
//                                     <label className="gst-checkbox-custom-label">
//                                         <input
//                                             type="checkbox"
//                                             checked={isGstSelected}
//                                             onChange={(e) => setIsGstSelected(e.target.checked)}
//                                         />
//                                         <span className="checkbox-text">Claim Corporate GST Credit?</span>
//                                     </label>

//                                     {isGstSelected && (
//                                         <div className="gst-input-slide-field">
//                                             <label>GSTIN Number</label>
//                                             <input
//                                                 type="text"
//                                                 maxLength={15}
//                                                 placeholder="e.g. 27AAAAA1111A1Z1"
//                                                 value={gstNumber}
//                                                 onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 <button
//                                     className="checkout-submit-payment-btn"
//                                     onClick={handlePayment}
//                                     disabled={
//                                         !orgName ||
//                                         !employeeCount ||
//                                         !!employeeError ||
//                                         !isCompanyEmailValid() ||
//                                         (isGstSelected && gstNumber.length < 15)
//                                     }
//                                 >
//                                     Proceed to Secure Payment
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </section>

//             <Footer />
//         </div>
//     );
// };

// export default PlanCheckout;
























// import React, { useState, useEffect } from "react";
// import { load } from "@cashfreepayments/cashfree-js";
// import { useLocation, useNavigate } from "react-router-dom";

// import Navbar from "../Navbar";
// import Footer from "../Footer";

// import "../styles/PlanCheckout.css";

// const subscriptionPlans = [
//     { months: 6, discount: 0 },
//     { months: 12, discount: 5 },
//     { months: 24, discount: 10 },
//     { months: 36, discount: 12 },
//     { months: 72, discount: 15 },
// ];

// const PlanCheckout = () => {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const location = useLocation();
//     const navigate = useNavigate();
//    const selectedPlan = location.state?.plan;
// const selectedProduct = location.state?.product;

//     // Form States
//     const [orgName, setOrgName] = useState("");
//     const [employeeCount, setEmployeeCount] = useState("");
//     const [employeeError, setEmployeeError] = useState("");
//     const [contactNumber, setContactNumber] = useState("");
//     const [companyEmail, setCompanyEmail] = useState("");
//     const [companyLogo, setCompanyLogo] = useState(null);

//     // Duration States
//     const [selectedMonths, setSelectedMonths] = useState(6);
//     const [selectedDiscount, setSelectedDiscount] = useState(0);

//     // GST Feature States
//     const [isGstSelected, setIsGstSelected] = useState(false);
//     const [gstNumber, setGstNumber] = useState("");

//     const blockedDomains = [
//         "gmail.com",
//         "yahoo.com",
//         "outlook.com",
//         "hotmail.com",
//         "icloud.com",
//         "rediffmail.com",
//     ];

//     const isCompanyEmailValid = () => {
//         if (!companyEmail) return true;
//         if (!companyEmail.includes("@")) return false;

//         const domain = companyEmail.split("@")[1]?.toLowerCase();
//         if (!domain) return false;

//         return !blockedDomains.includes(domain);
//     };

//     const handleEmployeeChange = (e) => {
//         const value = e.target.value;
//         setEmployeeCount(value);

//         if (value === "") {
//             setEmployeeError("");
//             return;
//         }

//         if (Number(value) < 10) {
//             setEmployeeError("At least 10 employees are required.");
//         } else {
//             setEmployeeError("");
//         }
//     };

//     const calculateAmount = (months, discount) => {
//         if (!employeeCount || Number(employeeCount) < 10 || !selectedPlan) {
//             return {
//                 finalAmount: 0,
//                 discountAmount: 0,
//                 baseAmount: 0,
//             };
//         }

//         const employees = Number(employeeCount);
//         const monthlyPrice = Number(
//             selectedPlan.price
//                 .replace("₹", "")
//                 .replace("+", "")
//                 .replace(",", "")
//         );

//         const baseAmount = employees * monthlyPrice * months;
//         const discountAmount = (baseAmount * discount) / 100;
//         const finalAmount = baseAmount - discountAmount;

//         return {
//             finalAmount,
//             discountAmount,
//             baseAmount,
//         };
//     };

//     if (!selectedPlan) {
//         return (
//             <div>
//                 <Navbar />
//                 <div className="checkout-error">No plan selected.</div>
//                 <Footer />
//             </div>
//         );
//     }

//     const pricing = calculateAmount(selectedMonths, selectedDiscount);
//     const cgst = (pricing.finalAmount * 9) / 100;
//     const sgst = (pricing.finalAmount * 9) / 100;
//     const grandTotal = pricing.finalAmount + cgst + sgst;

//     const handlePayment = async () => {
//         try {
//             if (!orgName || !employeeCount || employeeError || !isCompanyEmailValid()) {
//                 alert("Please fill all required details correctly");
//                 return;
//             }

//             const formData = new FormData();

//             formData.append("amount", Number(grandTotal.toFixed(2)));

//             formData.append("orgName", orgName);
//             formData.append("employeeCount", employeeCount);
//             formData.append("contactNumber", contactNumber);
//             formData.append("companyEmail", companyEmail);
//             formData.append("selectedMonths", selectedMonths);
//             formData.append("selectedPlan", selectedPlan.title);
//             formData.append("gstNumber", isGstSelected ? gstNumber : "");

//             if (companyLogo) {
//                 formData.append("companyLogo", companyLogo);
//             }

//             const response = await fetch("/gt-api/create_cashfree_order.php", {
//                 method: "POST",
//                 body: formData,
//             });
//             const rawText = await response.text();
//             console.log("RAW PHP RESPONSE:", rawText);

//             const data = JSON.parse(rawText);

//             console.log("Cashfree backend response:", data);

//             if (!data.success) {
//                 alert(JSON.stringify(data));
//                 return;
//             }
//             console.log("Full Backend Response:", data);
//             console.log("Session ID:", data.payment_session_id);

//             const cashfree = await load({
//                 mode: "production",
//             });
//             await cashfree.checkout({
//                 paymentSessionId: data.payment_session_id,
//                 redirectTarget: "_self",
//             });

//         } catch (error) {
//             console.error("Cashfree Error:", error);
//             alert(error.message || JSON.stringify(error));
//         }
//     };


//     return (
//         <div className="plan-checkout-wrapper">
//             <Navbar />

//             <section className="checkout-section">
//                 {/* TOP NAVIGATION HEADER */}
//                 <div className="checkout-header">
//                     <button className="backs-btn" onClick={() => navigate("/pricing")}>
//                         ← Back to Pricing
//                     </button>
//                     <h1>Subscription Checkout</h1>
//                 </div>

//                 {/* TWO-COLUMN SPLIT GRID LAYOUT */}
//                 <div className="checkout-main-layout">

//                     {/* LEFT COLUMN: INFORMATION & CONFIGURATION */}
//                     <div className="checkout-left-column">

//                         {/* 1. PLAN CONFIGURATION CARD */}
//                         <div className="checkout-card selected-plan-preview-card">
//                             <div className="card-header-accent">
//                                 <span className="badge">Selected Plan</span>
//                             </div>

//                             <div className="selected-plan-top">
//                               <div>
//     {selectedProduct && (
//         <div
//             style={{
//                 marginBottom: "12px",
//                 color: "#17d327",
//                 fontSize: "14px",
//                 fontWeight: "700",
//             }}
//         >
//             Product: {selectedProduct.name}
//         </div>
//     )}

//     <h3>{selectedPlan.title}</h3>

//     <p className="selected-plan-users">
//         {selectedPlan.users}
//     </p>
// </div>
//                                 <div className="plan-price-box">
//                                     <span className="price-num">{selectedPlan.price}</span>
//                                     <span className="price-unit">/user/month</span>
//                                 </div>
//                             </div>

//                             <div className="subscription-dropdown-inside">
//                                 <label htmlFor="tenure-select">Subscription Duration</label>
//                                 <select
//                                     id="tenure-select"
//                                     value={selectedMonths}
//                                     onChange={(e) => {
//                                         const selected = subscriptionPlans.find(
//                                             (p) => p.months === Number(e.target.value)
//                                         );
//                                         setSelectedMonths(selected.months);
//                                         setSelectedDiscount(selected.discount);
//                                     }}
//                                 >
//                                     {subscriptionPlans.map((plan, index) => (
//                                         <option key={index} value={plan.months}>
//                                             {plan.months} Months {plan.discount > 0 ? `(${plan.discount}% Eco-Save OFF)` : ""}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                         </div>

//                         {/* 2. CUSTOMER DETAILS FORM CARD */}
//                         <div className="checkout-card checkout-form-card">
//                             <h2>Organization Details</h2>
//                             <p className="form-subtitle">Please fill out your corporate profile below to establish account management defaults.</p>

//                             <div className="form-grid-layout">
//                                 <div className="input-group">
//                                     <label>Organization Name</label>
//                                     <input
//                                         type="text"
//                                         placeholder="e.g. Abc Corporation"
//                                         value={orgName}
//                                         onChange={(e) => setOrgName(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Number of Employees</label>
//                                     <input
//                                         type="number"
//                                         min="10"
//                                         placeholder="Minimum 10 seats required"
//                                         value={employeeCount}
//                                         onChange={handleEmployeeChange}
//                                     />
//                                     {employeeError && <p className="field-error-message">{employeeError}</p>}
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Contact Phone Number</label>
//                                     <input
//                                         type="text"
//                                         placeholder="+91 XXXXX XXXXX"
//                                         value={contactNumber}
//                                         onChange={(e) => setContactNumber(e.target.value)}
//                                     />
//                                 </div>

//                                 <div className="input-group">
//                                     <label>Company Email Address</label>
//                                     <input
//                                         type="email"
//                                         placeholder="name@yourcompany.com"
//                                         value={companyEmail}
//                                         onChange={(e) => setCompanyEmail(e.target.value)}
//                                     />
//                                     {!isCompanyEmailValid() && (
//                                         <p className="field-error-message">Please enter a valid company business email domain.</p>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* LOGO UPLOAD COMPONENT */}
//                             <div className="logo-upload-container">
//                                 <label className="upload-title">Company Logo Display</label>
//                                 <div className="logo-upload-box">
//                                     <div className="logo-meta-info">
//                                         <span className="file-status-text">
//                                             {companyLogo ? companyLogo.name : "No file chosen (Optional)"}
//                                         </span>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         className="choose-file-btn"
//                                         onClick={() => document.getElementById("logoUpload").click()}
//                                     >
//                                         Choose File
//                                     </button>
//                                     <input
//                                         id="logoUpload"
//                                         type="file"
//                                         accept="image/*"
//                                         style={{ display: "none" }}
//                                         onChange={(e) => setCompanyLogo(e.target.files[0])}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* RIGHT COLUMN: DYNAMIC ITEMIZED RECEIPT STICKY PANEL */}
//                     <div className="checkout-right-column">
//                         <div className="receipt-card sticky-receipt">
//                             <div className="receipt-header">
//                                 <h2>Receipt Summary</h2>
//                                 <span className="receipt-status-indicator">Live Calculation</span>
//                             </div>

//                             <div className="receipt-body">

//                                 {selectedProduct && (
//     <div className="receipt-row">
//         <span className="row-label">
//             Product
//         </span>

//         <span className="row-value plan-title-highlight">
//             {selectedProduct.name}
//         </span>
//     </div>
// )}
//                                 <div className="receipt-row">
//                                     <span className="row-label">Selected Tier</span>
//                                     <span className="row-value plan-title-highlight">{selectedPlan.title}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Assigned Seats</span>
//                                     <span className="row-value font-numeric">{employeeCount || 0} Employees</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Rate / User / Month</span>
//                                     <span className="row-value font-numeric">{selectedPlan.price}</span>
//                                 </div>
//                                 <div className="receipt-row">
//                                     <span className="row-label">Subscription Term</span>
//                                     <span className="row-value font-numeric">{selectedMonths} Months</span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row">
//                                     <span className="row-label">Base Cost</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.baseAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-row discount-row">
//                                     <span className="row-label">Tenure Discount ({selectedDiscount}%)</span>
//                                     <span className="row-value font-numeric">
//                                         - ₹{pricing.discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider"></div>

//                                 <div className="receipt-row subtotal-row">
//                                     <span className="row-label">Taxable Subtotal</span>
//                                     <span className="row-value font-numeric">
//                                         ₹{pricing.finalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">CGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{cgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>
//                                 <div className="receipt-row tax-row">
//                                     <span className="row-label">SGST (9%)</span>
//                                     <span className="row-value font-numeric">
//                                         + ₹{sgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 <div className="receipt-divider thick-divider"></div>

//                                 <div className="receipt-row grand-total-row">
//                                     <span className="total-label">Grand Total</span>
//                                     <span className="total-amount-display">
//                                         ₹{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//                                     </span>
//                                 </div>

//                                 {/* GST COMPLIANCE MODULE */}
//                                 <div className="gst-compliance-box">
//                                     <label className="gst-checkbox-custom-label">
//                                         <input
//                                             type="checkbox"
//                                             checked={isGstSelected}
//                                             onChange={(e) => setIsGstSelected(e.target.checked)}
//                                         />
//                                         <span className="checkbox-text">Claim Corporate GST Credit?</span>
//                                     </label>

//                                     {isGstSelected && (
//                                         <div className="gst-input-slide-field">
//                                             <label>GSTIN Number</label>
//                                             <input
//                                                 type="text"
//                                                 maxLength={15}
//                                                 placeholder="e.g. 27AAAAA1111A1Z1"
//                                                 value={gstNumber}
//                                                 onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 <button
//                                     className="checkout-submit-payment-btn"
//                                     onClick={handlePayment}
//                                     disabled={
//                                         !orgName ||
//                                         !employeeCount ||
//                                         !!employeeError ||
//                                         !isCompanyEmailValid() ||
//                                         (isGstSelected && gstNumber.length < 15)
//                                     }
//                                 >
//                                     Proceed to Secure Payment
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </section>

//             <Footer />
//         </div>
//     );
// };

// export default PlanCheckout;























import React, { useState, useEffect } from "react";
import { load } from "@cashfreepayments/cashfree-js";
import { useLocation, useNavigate } from "react-router-dom";

import Navbar from "../Navbar";
import Footer from "../Footer";

import "../styles/PlanCheckout.css";

const subscriptionPlans = [
    { months: 6, discount: 0 },
    { months: 12, discount: 5 },
    { months: 24, discount: 10 },
    { months: 36, discount: 12 },
    { months: 72, discount: 15 },
];

const PlanCheckout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const location = useLocation();
    const navigate = useNavigate();
    const selectedPlan = location.state?.plan;
    const selectedProduct = location.state?.product;
    const selectedCountry = location.state?.country || "India";


    const currencySymbol =
        selectedCountry === "US" ? "$" : "₹";

    const locale =
        selectedCountry === "US"
            ? "en-US"
            : "en-IN";

    // Form States
    const [orgName, setOrgName] = useState("");
    const [employeeCount, setEmployeeCount] = useState("");
    const [employeeError, setEmployeeError] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [companyLogo, setCompanyLogo] = useState(null);

    // Duration States
    const [selectedMonths, setSelectedMonths] = useState(6);
    const [selectedDiscount, setSelectedDiscount] = useState(0);

    // GST Feature States
    const [isGstSelected, setIsGstSelected] = useState(false);
    const [gstNumber, setGstNumber] = useState("");

    const blockedDomains = [
        "gmail.com",
        "yahoo.com",
        "outlook.com",
        "hotmail.com",
        "icloud.com",
        "rediffmail.com",
    ];

    const isCompanyEmailValid = () => {
        if (!companyEmail) return true;
        if (!companyEmail.includes("@")) return false;

        const domain = companyEmail.split("@")[1]?.toLowerCase();
        if (!domain) return false;

        return !blockedDomains.includes(domain);
    };

    const handleEmployeeChange = (e) => {
        const value = e.target.value;
        setEmployeeCount(value);

        if (value === "") {
            setEmployeeError("");
            return;
        }

        if (Number(value) < 10) {
            setEmployeeError("At least 10 employees are required.");
        } else {
            setEmployeeError("");
        }
    };

    const calculateAmount = (months, discount) => {
        if (!employeeCount || Number(employeeCount) < 10 || !selectedPlan) {
            return {
                finalAmount: 0,
                discountAmount: 0,
                baseAmount: 0,
            };
        }

        const employees = Number(employeeCount);
        const monthlyPrice =
            selectedCountry === "US"
                ? Number(selectedPlan.priceUSD)
                : Number(selectedPlan.priceINR);

        const baseAmount = employees * monthlyPrice * months;
        const discountAmount = (baseAmount * discount) / 100;
        const finalAmount = baseAmount - discountAmount;

        return {
            finalAmount,
            discountAmount,
            baseAmount,
        };
    };

    if (!selectedPlan) {
        return (
            <div>
                <Navbar />
                <div className="checkout-error">No plan selected.</div>
                <Footer />
            </div>
        );
    }

    const pricing = calculateAmount(selectedMonths, selectedDiscount);
    const cgst = (pricing.finalAmount * 9) / 100;
    const sgst = (pricing.finalAmount * 9) / 100;
    const grandTotal = pricing.finalAmount + cgst + sgst;

    const handlePayment = async () => {
        try {
            if (!orgName || !employeeCount || employeeError || !isCompanyEmailValid()) {
                alert("Please fill all required details correctly");
                return;
            }

            const formData = new FormData();

            formData.append("amount", Number(grandTotal.toFixed(2)));

            formData.append("orgName", orgName);
            formData.append("employeeCount", employeeCount);
            formData.append("contactNumber", contactNumber);
            formData.append("companyEmail", companyEmail);
            formData.append("selectedMonths", selectedMonths);
            formData.append("selectedPlan", selectedPlan.title);
            formData.append("gstNumber", isGstSelected ? gstNumber : "");

            if (companyLogo) {
                formData.append("companyLogo", companyLogo);
            }

            const response = await fetch("/gt-api/create_cashfree_order.php", {
                method: "POST",
                body: formData,
            });
            const rawText = await response.text();
            console.log("RAW PHP RESPONSE:", rawText);

            const data = JSON.parse(rawText);

            console.log("Cashfree backend response:", data);

            if (!data.success) {
                alert(JSON.stringify(data));
                return;
            }
            console.log("Full Backend Response:", data);
            console.log("Session ID:", data.payment_session_id);

            const cashfree = await load({
                mode: "production",
            });
            await cashfree.checkout({
                paymentSessionId: data.payment_session_id,
                redirectTarget: "_self",
            });

        } catch (error) {
            console.error("Cashfree Error:", error);
            alert(error.message || JSON.stringify(error));
        }
    };


    return (
        <div className="plan-checkout-wrapper">
            <Navbar />

            <section className="checkout-section">
                {/* TOP NAVIGATION HEADER */}
                <div className="checkout-header">
                    <button className="backs-btn" onClick={() => navigate("/pricing")}>
                        ← Back to Pricing
                    </button>
                    <h1>
                        Subscription Checkout
                        <span
                            style={{
                                marginLeft: "12px",
                                fontSize: "16px",
                                color: "#17d327",
                            }}
                        >
                            ({selectedCountry})
                        </span>
                    </h1>
                </div>

                {/* TWO-COLUMN SPLIT GRID LAYOUT */}
                <div className="checkout-main-layout">

                    {/* LEFT COLUMN: INFORMATION & CONFIGURATION */}
                    <div className="checkout-left-column">

                        {/* 1. PLAN CONFIGURATION CARD */}
                        <div className="checkout-card selected-plan-preview-card">
                            <div className="card-header-accent">
                                <span className="badge">Selected Plan</span>
                            </div>

                            <div className="selected-plan-top">
                                <div>
                                    {selectedProduct && (
                                        <div
                                            style={{
                                                marginBottom: "12px",
                                                color: "#17d327",
                                                fontSize: "14px",
                                                fontWeight: "700",
                                            }}
                                        >
                                            Product: {selectedProduct.name}
                                        </div>
                                    )}

                                    <h3>{selectedPlan.title}</h3>

                                    <p className="selected-plan-users">
                                        {selectedPlan.users}
                                    </p>
                                </div>
                                <div className="plan-price-box">
                                    <span className="price-num">
                                        {selectedCountry === "US"
                                            ? `$${selectedPlan.priceUSD}`
                                            : `₹${selectedPlan.priceINR}`}
                                    </span>
                                    <span className="price-unit">/user/month</span>
                                </div>
                            </div>

                            <div className="subscription-dropdown-inside">
                                <label htmlFor="tenure-select">Subscription Duration</label>
                                <select
                                    id="tenure-select"
                                    value={selectedMonths}
                                    onChange={(e) => {
                                        const selected = subscriptionPlans.find(
                                            (p) => p.months === Number(e.target.value)
                                        );
                                        setSelectedMonths(selected.months);
                                        setSelectedDiscount(selected.discount);
                                    }}
                                >
                                    {subscriptionPlans.map((plan, index) => (
                                        <option key={index} value={plan.months}>
                                            {plan.months} Months {plan.discount > 0 ? `(${plan.discount}% Eco-Save OFF)` : ""}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* 2. CUSTOMER DETAILS FORM CARD */}
                        <div className="checkout-card checkout-form-card">
                            <h2>Organization Details</h2>
                            <p className="form-subtitle">Please fill out your corporate profile below to establish account management defaults.</p>

                            <div className="form-grid-layout">
                                <div className="input-group">
                                    <label>Organization Name</label>
                                    <input
                                        type="text"
                                        placeholder="e.g. Abc Corporation"
                                        value={orgName}
                                        onChange={(e) => setOrgName(e.target.value)}
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Number of Employees</label>
                                    <input
                                        type="number"
                                        min="10"
                                        placeholder="Minimum 10 seats required"
                                        value={employeeCount}
                                        onChange={handleEmployeeChange}
                                    />
                                    {employeeError && <p className="field-error-message">{employeeError}</p>}
                                </div>

                                <div className="input-group">
                                    <label>Contact Phone Number</label>
                                    <input
                                        type="text"
                                        placeholder="+91 XXXXX XXXXX"
                                        value={contactNumber}
                                        onChange={(e) => setContactNumber(e.target.value)}
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Company Email Address</label>
                                    <input
                                        type="email"
                                        placeholder="name@yourcompany.com"
                                        value={companyEmail}
                                        onChange={(e) => setCompanyEmail(e.target.value)}
                                    />
                                    {!isCompanyEmailValid() && (
                                        <p className="field-error-message">Please enter a valid company business email domain.</p>
                                    )}
                                </div>
                            </div>

                            {/* LOGO UPLOAD COMPONENT */}
                            <div className="logo-upload-container">
                                <label className="upload-title">Company Logo Display</label>
                                <div className="logo-upload-box">
                                    <div className="logo-meta-info">
                                        <span className="file-status-text">
                                            {companyLogo ? companyLogo.name : "No file chosen (Optional)"}
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="choose-file-btn"
                                        onClick={() => document.getElementById("logoUpload").click()}
                                    >
                                        Choose File
                                    </button>
                                    <input
                                        id="logoUpload"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={(e) => setCompanyLogo(e.target.files[0])}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT COLUMN: DYNAMIC ITEMIZED RECEIPT STICKY PANEL */}
                    <div className="checkout-right-column">
                        <div className="receipt-card sticky-receipt">
                            <div className="receipt-header">
                                <h2>Receipt Summary</h2>
                                <span className="receipt-status-indicator">Live Calculation</span>
                            </div>

                            <div className="receipt-body">

                                {selectedProduct && (
                                    <div className="receipt-row">
                                        <span className="row-label">
                                            Product
                                        </span>

                                        <span className="row-value plan-title-highlight">
                                            {selectedProduct.name}
                                        </span>
                                    </div>
                                )}
                                <div className="receipt-row">
                                    <span className="row-label">Selected Tier</span>
                                    <span className="row-value plan-title-highlight">{selectedPlan.title}</span>
                                </div>
                                <div className="receipt-row">
                                    <span className="row-label">Assigned Seats</span>
                                    <span className="row-value font-numeric">{employeeCount || 0} Employees</span>
                                </div>
                                <div className="receipt-row">
                                    <span className="row-label">Rate / User / Month</span>
                                    <span className="row-value font-numeric">{selectedCountry === "US"
                                        ? `$${selectedPlan.priceUSD}`
                                        : `₹${selectedPlan.priceINR}`}</span>
                                </div>
                                <div className="receipt-row">
                                    <span className="row-label">Subscription Term</span>
                                    <span className="row-value font-numeric">{selectedMonths} Months</span>
                                </div>

                                <div className="receipt-divider"></div>

                                <div className="receipt-row">
                                    <span className="row-label">Base Cost</span>
                                    <span className="row-value font-numeric">
                                        {currencySymbol}
                                        {pricing.baseAmount.toLocaleString(locale, {
                                            minimumFractionDigits: 2
                                        })}
                                    </span>
                                </div>

                                <div className="receipt-row discount-row">
                                    <span className="row-label">Tenure Discount ({selectedDiscount}%)</span>
                                    <span className="row-value font-numeric">
                                        - {currencySymbol}
                                        {pricing.discountAmount.toLocaleString(locale, {
                                            minimumFractionDigits: 2
                                        })}
                                    </span>
                                </div>

                                <div className="receipt-divider"></div>

                                <div className="receipt-row subtotal-row">
                                    <span className="row-label">Taxable Subtotal</span>
                                    <span className="row-value font-numeric">
                                        {currencySymbol}
                                        {pricing.finalAmount.toLocaleString(locale, {
                                            minimumFractionDigits: 2
                                        })}
                                    </span>
                                </div>
                                {selectedCountry === "India" && (
                                    <>
                                        <div className="receipt-row tax-row">
                                            <span className="row-label">
                                                CGST (9%)
                                            </span>

                                            <span className="row-value font-numeric">
                                                + {currencySymbol}
                                                {cgst.toLocaleString(locale, {
                                                    minimumFractionDigits: 2
                                                })}
                                            </span>
                                        </div>

                                        <div className="receipt-row tax-row">
                                            <span className="row-label">
                                                SGST (9%)
                                            </span>

                                            <span className="row-value font-numeric">
                                                + {currencySymbol}
                                                {sgst.toLocaleString(locale, {
                                                    minimumFractionDigits: 2
                                                })}
                                            </span>
                                        </div>
                                    </>
                                )}

                                <div className="receipt-divider thick-divider"></div>

                                <div className="receipt-row grand-total-row">
                                    <span className="total-label">Grand Total</span>
                                    <span className="total-amount-display">
                                        {currencySymbol}
                                        {grandTotal.toLocaleString(locale, {
                                            minimumFractionDigits: 2
                                        })}
                                    </span>
                                </div>

                                {/* GST COMPLIANCE MODULE */}
                                <div className="gst-compliance-box">
                                    <label className="gst-checkbox-custom-label">
                                        <input
                                            type="checkbox"
                                            checked={isGstSelected}
                                            onChange={(e) => setIsGstSelected(e.target.checked)}
                                        />
                                        <span className="checkbox-text">Claim Corporate GST Credit?</span>
                                    </label>

                                    {isGstSelected && (
                                        <div className="gst-input-slide-field">
                                            <label>GSTIN Number</label>
                                            <input
                                                type="text"
                                                maxLength={15}
                                                placeholder="e.g. 27AAAAA1111A1Z1"
                                                value={gstNumber}
                                                onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
                                            />
                                        </div>
                                    )}
                                </div>

                                <button
                                    className="checkout-submit-payment-btn"
                                    onClick={handlePayment}
                                    disabled={
                                        !orgName ||
                                        !employeeCount ||
                                        !!employeeError ||
                                        !isCompanyEmailValid() ||
                                        (isGstSelected && gstNumber.length < 15)
                                    }
                                >
                                    Proceed to Secure Payment
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    );
};

export default PlanCheckout;


